module.exports = __webpack_public_path__ + "static/media/PennymacLogo2025.9f8fd934.svg";